import HelperLine, { VERTICAL } from '../../components/header/utils/helper-line'

export function createHelperLine({ border }) {
  return {
    verHelperLine: new HelperLine({border, VERTICAL}),
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/config/helper-line.js